import React from 'react'

import { Alert } from 'components/shared/Alert/Alert'

export const MessageAlert = ({
  className,
  message,
  size,
  variant,
  isInitialised,
}) => (
  <Alert {...{ className, message, size, variant, isInitialised }}>
    <Alert.Message />
  </Alert>
)
